import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import UsageBadge from './UsageBadge/UsageBadge';
import './Layout.css';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const { t, language, toggleLanguage } = useLanguage();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/login');
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const menuItems = [
    {
      path: '/dashboard',
      icon: '🏠',
      label: t('dashboard'),
    },
    {
      path: '/analyze',
      icon: '📸',
      label: t('analyze_food'),
    },
    {
      path: '/history',
      icon: '📋',
      label: t('history'),
    },
    {
      path: '/nutrition',
      icon: '🥗',
      label: t('nutrition_tracking'),
    },
    {
      path: '/profile',
      icon: '👤',
      label: t('profile'),
    },
  ];

  return (
    <div className="layout">
      {/* Top Navigation Bar */}
      <header className="navbar">
        <div className="navbar-left">
          <button className="menu-toggle" onClick={toggleSidebar}>
            <span className="hamburger-icon">☰</span>
          </button>
          <Link to="/dashboard" className="navbar-brand">
            <span className="brand-icon">🍽️</span>
            <span className="brand-text">{t('app_name')}</span>
          </Link>
        </div>

        <div className="navbar-right">
          <button className="language-btn" onClick={toggleLanguage}>
            {language === 'uz' ? '🇬🇧 EN' : '🇺🇿 UZ'}
          </button>

          <div className="user-menu">
            <button
              className="user-menu-toggle"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <span className="user-avatar">
                {user?.full_name?.charAt(0)?.toUpperCase() || '👤'}
              </span>
              <span className="user-name">{user?.full_name || 'User'}</span>
              <span className="dropdown-arrow">▼</span>
            </button>

            {showUserMenu && (
              <div className="user-dropdown">
                <Link
                  to="/profile"
                  className="dropdown-item"
                  onClick={() => setShowUserMenu(false)}
                >
                  <span className="dropdown-icon">👤</span>
                  {t('profile')}
                </Link>
                <button className="dropdown-item" onClick={handleLogout}>
                  <span className="dropdown-icon">🚪</span>
                  {t('logout')}
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <UsageBadge />
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive(item.path) ? 'nav-item-active' : ''}`}
              onClick={closeSidebar}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>
      </aside>

      {/* Sidebar Overlay (for mobile) */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}

      {/* Main Content */}
      <main className="main-content">
        <div className="content-container">{children}</div>
      </main>
    </div>
  );
};

export default Layout;
